import { AxiosResponse } from "axios";
import { useBack } from "../http";
import { LgpdPolicyDTO } from "../types/LgpdPolicyDTO";

export class LgpdService {
	constructor() {}
	axiosInstance = useBack();

	public async getPolicy(groupId: string): Promise<AxiosResponse<LgpdPolicyDTO>> {
		return this.axiosInstance.get(`/audit/group/${groupId}/lgpd-policy`);
	}

	public async updatePolicy(groupId: string, policy: LgpdPolicyDTO): Promise<AxiosResponse<LgpdPolicyDTO>> {
		return this.axiosInstance.put(`/audit/group/${groupId}/lgpd-policy`, policy);
	}
}